var _rect, _rect2, _rect3, _rect4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint0_linear_3959_6469)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint1_linear_3959_6469)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint2_linear_3959_6469)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint3_linear_3959_6469)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 20C24.4538 20 25.2487 20.3292 25.8347 20.9153C26.4208 21.5013 26.75 22.2962 26.75 23.125C26.75 23.9538 26.4208 24.7487 25.8347 25.3347C25.2487 25.9208 24.4538 26.25 23.625 26.25C22.7962 26.25 22.0013 25.9208 21.4153 25.3347C20.8292 24.7487 20.5 23.9538 20.5 23.125C20.5 22.2962 20.8292 21.5013 21.4153 20.9153C22.0013 20.3292 22.7962 20 23.625 20ZM38 20C38.8288 20 39.6237 20.3292 40.2097 20.9153C40.7958 21.5013 41.125 22.2962 41.125 23.125C41.125 23.9538 40.7958 24.7487 40.2097 25.3347C39.6237 25.9208 38.8288 26.25 38 26.25C37.1712 26.25 36.3763 25.9208 35.7903 25.3347C35.2042 24.7487 34.875 23.9538 34.875 23.125C34.875 22.2962 35.2042 21.5013 35.7903 20.9153C36.3763 20.3292 37.1712 20 38 20ZM18 31.668C18 29.3672 19.8672 27.5 22.168 27.5H23.8359C24.457 27.5 25.0469 27.6367 25.5781 27.8789C25.5273 28.1602 25.5039 28.4531 25.5039 28.75C25.5039 30.2422 26.1602 31.582 27.1953 32.5H18.832C18.375 32.5 18 32.125 18 31.668ZM33.832 32.5H33.8047C34.8438 31.582 35.4961 30.2422 35.4961 28.75C35.4961 28.4531 35.4688 28.1641 35.4219 27.8789C35.9531 27.6328 36.543 27.5 37.1641 27.5H38.832C41.1328 27.5 43 29.3672 43 31.668C43 32.1289 42.625 32.5 42.168 32.5H33.832ZM26.75 28.75C26.75 27.7554 27.1451 26.8016 27.8483 26.0983C28.5516 25.3951 29.5054 25 30.5 25C31.4946 25 32.4484 25.3951 33.1517 26.0983C33.8549 26.8016 34.25 27.7554 34.25 28.75C34.25 29.7446 33.8549 30.6984 33.1517 31.4017C32.4484 32.1049 31.4946 32.5 30.5 32.5C29.5054 32.5 28.5516 32.1049 27.8483 31.4017C27.1451 30.6984 26.75 29.7446 26.75 28.75ZM23 38.957C23 36.082 25.332 33.75 28.207 33.75H32.793C35.668 33.75 38 36.082 38 38.957C38 39.5312 37.5352 40 36.957 40H24.043C23.4688 40 23 39.5352 23 38.957Z",
    fill: "#A685FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3959_6469",
    x1: 4.93903,
    y1: 63.2927,
    x2: 62.7439,
    y2: -4.02439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3959_6469",
    x1: 59.8171,
    y1: -7.68292,
    x2: 4.93902,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3959_6469",
    x1: 3.20968,
    y1: 10.4839,
    x2: 51.8226,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3959_6469",
    x1: 60.6935,
    y1: 61.9355,
    x2: 9.59677,
    y2: 25.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#A685FA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.f968bde16db012e71faeae71d529e10d.svg";
export { ForwardRef as ReactComponent };